import { Content } from '../../types';

export const khaosanRoadContent: Content = {
  title: 'רחוב הקאוסאן והמרחב הסמוך אליו',
  imageUrl: '/images/thailand/khao-san/khao-san-wide.jpg',
  introduction:
    'רחוב הקאוסאן, שבשכונת בנג למפו (Bang Lamphu) שבבנגקוק והרחובות הסמוכים אליו, משמשים אחד מהמקומות הצבעוניים והמיוחדים של העיר ושל המדינה כולה.',
  sections: [
    {
      title: 'פני הרחוב לאורך היום',
      type: 'sub-headers',
      description:
        'רחובות הקאוסאן והסביבה משנים את פניהם מספר פעמים ביום, כאשר כל שעה מציעה חוויה שונה לחלוטין:',
      content: [
        {
          subtitle: 'שעות הבוקר המוקדמות',
          text: 'בשעות הבוקר המוקדמות שוק ירקות, פירות ואוכל מקומי, כאשר התמונה היפה והאותנטית הינה של הנזירים היוצאים לרחובות כדי לקבל אוכל מהעם והעם התאילנדי אכן מגיע למקום, תורם ומתברך על ידם, בהתאם למנהגי הדת הבודהיסטית.',
        },
        {
          subtitle: 'במהלך היום',
          text: "לאחר מכן ובמהלך רוב שעות היום, משמש האזור לסחר בגדים, מזכרות, תכשיטים, תיקים ועוד. רחובות הקאוסאן ורמבוטרי משמשים גם כמתחמים תיירותיים עם מסעדות, בתי קפה, ברים, מכוני מסאג' ועוד.",
        },
        {
          subtitle: 'חיי הלילה',
          text: "בשעות הלילה, הופך רחוב הקאוסאן לאחד ממרכזי חיי הלילה של העיר, אם לא המרכזי שבהם, עם חיי לילה רועשים ותוססים, מועדונים רבים, מוזיקה חיה ומגוונת והמוני מבלים, תיירים ומקומיים יחדיו, עד השעות הקטנות של הלילה. רחוב רמבוטרי, המקביל אליו, משמש אף הוא כחלק בלתי נפרד מחיי הלילה של האזור אך במאפיין סולידי ושקט יותר. הרבה ברים, מועדונים שקטים (יחסית לרח' הקאוסאן), מסעדות, מסאג'ים ודוכני רחוב רבים עם מגוון מוצרים ובעיקר, אווירה מיוחדת.",
        },
      ],
    },
    {
      title: 'דוכני רחוב הקאוסאן',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/khao-san/khao-san-article-1.jpg',
    },
    {
      title: 'מידע שימושי למטיילים',
      type: 'sub-headers',
      description:
        'האזור מציע מגוון שירותים וחשוב להכיר את האפשרויות העומדות בפני המטיילים:',
      content: [
        {
          subtitle: 'שירותי תיירות ואטרקציות סמוכות',
          text: 'באזור, קיימים בתי מלון רבים ואכסניות רבות, בדרגות אירוח שונות, מסעדות רבות עם מגוון רחב של מאכלים, כלל שירותי התיירות הנדרשים עבור התיירים ובמרחק קצר מהאזור, אף אתרי תיירות מרכזיים, כמתחם ארמון המלך, המקדשים וואט פו, וואט ארון, שוק הפרחים ועוד.',
        },
        {
          subtitle: 'מוקד לתרמילאים',
          text: 'האזור מהווה יעד מרכזי עבור תרמילאים ונקודת יציאה מרכזית לטיולים. האכסניות ובתי המלון הקטנים מהווים נקודות מפגש לתרמילאים מכל העולם. בית חב"ד למטיילים בבנגקוק, ממוקם אף הוא באזור זה, ברחוב Phra Athit.',
        },
        {
          subtitle: 'דרכי הגעה',
          text: "למתאכסנים באזורים אחרים בעיר, ניתן להגיע למקום, מעבר לתחבורה ציבורית רגילה, אף באמצעות הספינות הציבוריות והתיירותיות שבנהר צ'או פראייה (תחנת Phra Athit) וסירות התעלה (רציף Pan Fa), אך אלו אינן פעילות בשעות הלילה.",
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        'רחוב הקאוסאן והאזור הסובב אותו מהווים חוויה תיירותית ייחודית ומגוונת במיוחד, המשתנה בין שעות היממה השונות. בין אם אתם מעוניינים לחוות את התרבות המקומית בשעות הבוקר, לערוך קניות במהלך היום או לצאת לבלות בלילה, האזור מציע את כל אלו במרחק הליכה, יחד עם שירותי תיירות מקיפים ונגישות לאתרים מרכזיים נוספים בבנגקוק.',
      type: 'text',
      isBold: true,
    },
  ],
};
